export default __webpack_public_path__ + "static/media/Ballroll_00124.57e117b9.png";